module.exports = __webpack_public_path__ + "static/media/truck.cee8c688.svg";